import publicAxios from './publicAxios';

// Fetch all homepage data in a single request
export const fetchHomepageData = async () => {
  try {
    const response = await publicAxios.get('/core/homepage/all_data/');
    return response.data;
  } catch (error) {
    console.error('Error fetching homepage data:', error);
    throw error;
  }
};

// Fetch live statistics
export const fetchLiveStats = async () => {
  try {
    const response = await publicAxios.get('/core/stats/live_stats/');
    return response.data;
  } catch (error) {
    console.error('Error fetching live stats:', error);
    throw error;
  }
};

// Fetch testimonials
export const fetchTestimonials = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.type) queryParams.append('type', params.type);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const response = await publicAxios.get(`/core/testimonials/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

// Fetch features
export const fetchFeatures = async () => {
  try {
    const response = await publicAxios.get('/core/features/');
    return response.data;
  } catch (error) {
    console.error('Error fetching features:', error);
    throw error;
  }
};

// Fetch search suggestions
export const fetchSearchSuggestions = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.type) queryParams.append('type', params.type);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const response = await publicAxios.get(`/core/search-suggestions/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching search suggestions:', error);
    throw error;
  }
};

// Fetch locations
export const fetchLocations = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.state) queryParams.append('state', params.state);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const response = await publicAxios.get(`/core/locations/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};

// Increment search count for a suggestion
export const incrementSearchCount = async (text, type = 'popular') => {
  try {
    const response = await publicAxios.post('/core/search-suggestions/increment_search_count/', {
      text,
      type
    });
    return response.data;
  } catch (error) {
    console.error('Error incrementing search count:', error);
    // Don't throw error as this is not critical
  }
};

// Fetch homepage configuration
export const fetchHomepageConfiguration = async () => {
  try {
    const response = await publicAxios.get('/core/configuration/');
    return response.data;
  } catch (error) {
    console.error('Error fetching homepage configuration:', error);
    throw error;
  }
}; 